import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
  isLoading: boolean;
  message?: string;
  componentIds: string[],
}

const initialState: LoadingState = {
  isLoading: false,
  componentIds: [],
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    showLoading: (state, action: PayloadAction<string>) => {
      if (!state.componentIds.includes(action.payload)) {
        state.componentIds = [...state.componentIds, action.payload];
        state.isLoading = true;
      }
    },

    hideLoading: (state, action: PayloadAction<string>) => {
      if (state.componentIds.includes(action.payload)) {
        state.componentIds = state.componentIds.filter(id => id != action.payload);
      }
      if (!state.componentIds.length) {
        state.isLoading = false;
      }
    },
  },
});

export const { showLoading, hideLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
